import DashboardCard from 'Core/components/Dashboard/Card';
import 'Core/components/Dashboard/Dashboard.sass';
import {showModal} from 'Core/ducks/modal';
import React, {useEffect} from 'react';
import {connect, useDispatch, useSelector} from 'react-redux';
import {RouteComponentProps, withRouter} from 'react-router';
import {ReducerState} from 'rootReducer';
import RequireScope from 'Shared/components/RequireScope';
import withUserClaims, {WithClaimsProps} from 'Shared/components/withUserClaims';
import {AgentNumberStatusId} from 'Shared/constants/AgentNumberStatus';
import {Scope} from 'Shared/constants/Scope';
import {isAgencyInStatus, loadUserClaims, selectUserScopes} from 'Users/selectors/userProfileSelectors';
import {EnrollmentRouteConstants} from 'Enrollment/Routes';
import {Grid} from '@material-ui/core';
import {AsyncUserClaims} from 'Users/models/Claims';


type ExternalEnrollTrackDashboardProps = {
  showModal: typeof showModal;
} & ReturnType<typeof mapStateToProps> &
  WithClaimsProps & {userClaims: AsyncUserClaims} & RouteComponentProps;
  export const ExternalEnrollTrackDashboard = (props: ExternalEnrollTrackDashboardProps) => {
    return (
      <div className="dashboard">
        <Grid container spacing={4}>
          <Grid item xs={12}>
            <h1 className="dashboard__welcome-message">
              Welcome&nbsp;
              {props.claims.firstName}
            </h1>
          </Grid>
          <RequireScope scopes={props.scopes} scope={Scope.SearchFileUpload}>
            <Grid item lg={3} md={4} sm={6} xs={12}>
              <DashboardCard
                image={() => <i className="fa fa-upload" />}
                title="File Upload"
                description="Enrollment File Upload"
                linkText="View Files"
                onClickLink={() => {
                  props.history.push(EnrollmentRouteConstants.FILE_UPLOAD);
                }}
              />
            </Grid>
          </RequireScope>
        </Grid>
      </div>
    );
  };

const mapStateToProps = (state: ReducerState) => ({
  scopes: selectUserScopes(state),
  isTerminatedAgent: isAgencyInStatus(state, AgentNumberStatusId.Terminated),
});

export default withUserClaims(
  withRouter(
    connect(mapStateToProps, {
      showModal,
    })(ExternalEnrollTrackDashboard)
  )
);
